// Traducciones en español para el formulario de opiniones
const opinionForm = {
  title: "¡Danos tu Opinión!",
  alerts: {
    thankYou: "¡Gracias por tu opinión!",
    error: "Hubo un problema al enviar tus datos.",
  },
  buttons: {
    submit: "Enviar",
    back: "Volver",
  },
  question1: {
    label: "1. Sexo *",
    option1: "Hombre",
    option2: "Mujer",
    option3: "Otro",
    error: "Este campo es obligatorio.",
  },
  question2: {
    label: "2. Edad (años) *",
    error: "Por favor, introduce una edad válida.",
  },
  question3: {
    label: "3. Código Postal (CP.) *",
    error: "Introduce un código postal válido (5 dígitos).",
  },
  question4: {
    label: "4. ¿Has leído el cómic en formato digital o impreso en papel? *",
    option1: "Digital",
    option2: "Impreso",
    error: "Este campo es obligatorio.",
  },
  question5: {
    label: "5. ¿Eres lector habitual de cómics?",
    description:
      "Valora de 1 a 5, donde 1 significa <bold>Nunca</bold> y 5 significa <bold>Todos los días</bold>.",
    error: "Este campo es obligatorio.",
  },
  question6: {
    label:
      "6. ¿Has estado alguna vez en el lugar/monumento donde se desarrolla la historia? *",
    option1: "Sí",
    option2: "No",
    error: "Este campo es obligatorio.",
  },
  question7: {
    label: "7. ¿Conocías el lugar/monumento? *",
    option1: "Sí",
    option2: "No",
    error: "Este campo es obligatorio.",
  },
  question8: {
    label: "8. ¿Te gustaría visitar el lugar ahora que has leído el cómic?",
    description:
      "Valora de 1 a 5, donde 1 significa <bold>No lo visitaría</bold> y 5 significa <bold>Definitivamente sí</bold>.",
    error: "Este campo es obligatorio.",
  },
  emotionsGroup: {
    label:
      "9. Valora las emociones que te sugiera el monumento en el que se desarrolla la historia",
  },
  question9: {
    description:
      "Valora de 1 a 5, donde 1 significa <bold>Indiferencia</bold> y 5 significa <bold>Curiosidad</bold>.",
    error: "Este campo es obligatorio.",
  },
  question10: {
    description:
      "Valora de 1 a 5, donde 1 significa <bold>Desprecio</bold> y 5 significa <bold>Orgullo</bold>.",
    error: "Este campo es obligatorio.",
  },
  question11: {
    description:
      "Valora de 1 a 5, donde 1 significa <bold>Vulnerabilidad del monumento</bold> y 5 significa <bold>Perdurabilidad</bold>.",
    error: "Este campo es obligatorio.",
  },
  question12: {
    label: "10. ¿El tiempo de lectura te ha resultado? *",
    option1: "Corto",
    option2: "Adecuado",
    option3: "Largo",
    error: "Este campo es obligatorio.",
  },
  question13: {
    label:
      "11. Se entienden bien los flashbacks (recuerdos del pasado) de Zaquiel? *",
    option1: "Sí",
    option2: "No",
    error: "Este campo es obligatorio.",
  },
  question14: {
    label: "12. ¿Prefiere el cómic digital o impreso? *",
    option1: "Digital",
    option2: "Impreso",
    option3: "Ambos (Indiferente)",
    option4: "NS/NC",
    error: "Este campo es obligatorio.",
  },
  question15: {
    label:
      "13. ¿Te gustaría conocer cómo siguen las aventuras de Zaquiel? *",
    description:
      "Valora de 1 a 5, donde 1 significa <bold>De ningún modo</bold> y 5 <bold>Sin duda sí</bold>",
    error: "Este campo es obligatorio.",
  },
  question16: {
    label:
      "14. ¿Crees que la narrativa del cómic permite entender cómo es el monumento? *",
    description:
      "Valora de 1 a 5, donde 1 significa <bold>Para nada</bold> y 5 <bold>Con plena seguridad</bold>",
    error: "Este campo es obligatorio.",
  },
  question17: {
    label: "15. Comentarios (opcional)",
  },
  chapter: {
    label: "16. ¿A qué capítulo se refiere tu opinión? *",
    option1: "Capítulo 1",
    option2: "Capítulo 2",
    option3: "Capítulo 3",
    option4: "Capítulo 4",
    option5: "Capítulo 5",
    option6: "Capítulo 6",
    option7: "Capítulo 7",
    option8: "Capítulo 8",
    option9: "Capítulo 9",
    error: "Por favor, selecciona un capítulo.",
  },
  gdpr: {
    label:
      "Acepto el tratamiento y almacenamiento de mis datos conforme a la Política de Privacidad *",
    error: "Debes aceptar el tratamiento de datos para continuar.",
  },
};

export default opinionForm; 